import { useEffect, useState } from 'react';
import { Text } from '@mantine/core';
import { collection, onSnapshot, query, where, limit } from 'firebase/firestore';
import { useFirestore } from '../../helpers/firebaseContext';
import type { Security } from '../../types';

/** Read-only KCC display, including catalogue fallback for older transactions. */
export default function TransactionSecurityKcc({ security }: { security?: Security }) {
    const db = useFirestore();
    const [catalogue, setCatalogue] = useState<{ identity: string; kcc: string }>();
    const identity = JSON.stringify([security?.CODE, security?.EXCHANGE_CODE]);
    useEffect(() => {
        if (!security?.CODE || !security.EXCHANGE_CODE) return;
        return onSnapshot(query(collection(db, 'securities'), where('CODE', '==', security.CODE), where('EXCHANGE_CODE', '==', security.EXCHANGE_CODE), limit(2)), snapshot => {
            const kcc = snapshot.size === 1 ? snapshot.docs[0].data().KCC_NUMBER : undefined;
            setCatalogue({ identity, kcc: kcc == null ? '' : String(kcc) });
        }, () => setCatalogue({ identity, kcc: '' }));
    }, [db, security?.CODE, security?.EXCHANGE_CODE, identity]);
    return <Text size="sm">{security?.KCC_NUMBER || (catalogue?.identity === identity ? catalogue.kcc : '') || '—'}</Text>;
}
